import { render, staticRenderFns } from "./videoTemp.vue?vue&type=template&id=61af66c6&scoped=true&"
import script from "./videoTemp.vue?vue&type=script&lang=js&"
export * from "./videoTemp.vue?vue&type=script&lang=js&"
import style0 from "./videoTemp.vue?vue&type=style&index=0&id=61af66c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af66c6",
  null
  
)

export default component.exports